import styles from '../css/Loader.module.scss';
export const Loader = () => {
    return (
        <div className='mt-5 text-center'>
            <span className={"mx-auto mb-3 " +  styles.loader}></span>
            <span className="mt-4 fw-medium">Cargando</span>
        </div>
    )
}